export default "__VITE_ASSET__BktIZUou__"